import React, { lazy, Suspense } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import './App.css';

const Stay = lazy(() => import('./pages/Stay'));
const Rates = lazy(() => import('./pages/Rates'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Location = lazy(() => import('./pages/Location'));
const Contact = lazy(() => import('./pages/Contact'));
const BookingConfirmation = lazy(() => import('./pages/BookingConfirmation'));
const LocalFinds = lazy(() => import('./pages/LocalFinds'));
const ScenicViews = lazy(() => import('./pages/ScenicViews'));
const PahiyasSpirit = lazy(() => import('./pages/PahiyasSpirit'));
const WarmWelcome = lazy(() => import('./pages/WarmWelcome'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Login = lazy(() => import('./pages/Admin/Login'));
const Dashboard = lazy(() => import('./pages/Admin/Dashboard'));
const ApiDocs = lazy(() => import('./pages/Admin/ApiDocs'));
const IcalSync = lazy(() => import('./pages/Admin/IcalSync'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white text-brand-olive">
    <span className="text-xs font-bold uppercase tracking-[0.2em]">Loading R.Venue…</span>
  </div>
);

function App() {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
        {/* Admin Routes */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/admin/api-docs" element={<ApiDocs />} />
        <Route path="/admin/ical-sync" element={<IcalSync />} />

        {/* Public Routes with MainLayout */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/stay" element={<Stay />} />
          <Route path="/rates" element={<Rates />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/location" element={<Location />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking-confirmation" element={<BookingConfirmation />} />
          <Route path="/local-finds" element={<LocalFinds />} />
          <Route path="/scenic-views" element={<ScenicViews />} />
          <Route path="/pahiyas-spirit" element={<PahiyasSpirit />} />
          <Route path="/warm-welcome" element={<WarmWelcome />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Route>

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
